<template>
  <nav id="sidebar" class="page-sidebar" data-pages="sidebar">
    <!-- SIDEBAR HEADER -->
    <div class="sidebar-header">
      <div class="row justify-content-center">
        <!-- PROJECT LOGO -->
        <div class="col-9" align="right">
          <!-- <img src="../../../public/assets/img/logo.png" alt="logo" class="brand" height="35"
            style="max-width: 100%; margin-right:0.75rem" @error="logo_proyek = null" />
          <img src="../../../public/assets/img/logo_au.png" alt="logo" class="brand" height="35" style="max-width: 100%"
            @error="logo_proyek = null" /> -->
        </div>
        <!-- MENU BUTTON -->
        <div class="col-3" align="center">
          <button aria-label="Pin Menu" type="button"
            class="btn btn-icon-link invert d-lg-inline-block d-xlg-inline-block d-md-inline-block d-sm-none d-none"
            data-toggle-pin="sidebar">
            <i class="pg-icon"></i>
          </button>
        </div>
      </div>
    </div>
    <!-- SIDEBAR MENU -->
    <div class="sidebar-menu">
      <!-- MENU ITEMS-->
      <ul class="menu-items">
        <!-- DASHBOARD -->
        <li class="m-t-20" @click="navAction">
          <router-link to="/dashboard" class="detailed">
            Beranda
          </router-link>
          <span class="icon-thumbnail"><i class="bi bi-speedometer"></i></span>
        </li>
        <!-- MENTION -->
        <li class="" @click="navAction">
          <router-link to="/posts" class="detailed"> Mentions </router-link>
          <span class="icon-thumbnail"><i class="bi bi-chat-left-text" /></span>
        </li>
        <!-- HOAX -->
        <li class="" @click="navAction">
          <!-- <router-link to="/hoax" class="detailed"> Hoax </router-link> -->
          <router-link to="/hoax" class="detailed"> Bot & Hoaks </router-link>
          <span class="icon-thumbnail"><i class="bi bi-exclamation-triangle" /></span>
        </li>
        <!-- SOURCE -->
        <li class="" @click="navAction">
          <!-- <router-link to="/sources" class="detailed"> Source </router-link> -->
          <router-link to="/sources" class="detailed"> Sumber </router-link>
          <span class="icon-thumbnail"><i class="bi bi-layers" /></span>
        </li>
        <!-- SEARCH -->
        <li class="" @click="navAction" v-if="tipe == 1 && isSearch == 1">
          <!-- <router-link to="/search" class="detailed"> Search </router-link> -->
          <router-link to="/search" class="detailed"> Cari </router-link>
          <span class="icon-thumbnail"><i class="bi bi-search" /></span>
        </li>
        <!-- NEWS TREND -->
        <li class="" @click="navAction" v-if="is_newstrend == 'manage' && news_trend > 0">
          <!-- <router-link to="/newstrend" class="detailed">
            News Trend
          </router-link> -->
          <router-link to="/newstrend" class="detailed">
            Tren Baru
          </router-link>
          <span class="icon-thumbnail">
            <i class="bi bi-graph-up-arrow"> </i>
          </span>
        </li>
        <!-- DATA CLEANSING -->
        <!-- <li class="" @click="navAction" v-if="is_clean == 'manage'">
          <router-link to="/cleansing" class="detailed">
            Data Cleansing
          </router-link>
          <span class="icon-thumbnail"><i class="bi bi-eraser"></i></span>
        </li> -->
        <!-- ANALYTICS -->
        <li>
          <a href="javascript:;">
            <!-- <span class="title"> Analytics </span> <span class="arrow"></span> -->
            <span class="title"> Analitik </span> <span class="arrow"></span>
          </a>
          <span class="icon-thumbnail">
            <i class="bi bi-bar-chart-steps"> </i>
          </span>
          <!-- ANALYTICS MENU -->
          <ul class="sub-menu">
            <!-- GENERAL -->
            <li class="" @click="navAction">
              <!-- <router-link to="/analytics" class="detailed">
                General
              </router-link> -->
              <router-link to="/analytics" class="detailed">
                Umum
              </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-bar-chart-line"></i>
              </span>
            </li>
            <!-- MAPS -->
            <li class="" @click="navAction">
              <!-- <router-link to="/maps" class="detailed"> Maps </router-link> -->
              <router-link to="/maps" class="detailed"> Peta </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-map"></i>
              </span>
            </li>
            <!-- SNA -->
            <li v-if="is_sna" class="" @click="navAction">
              <router-link to="/sna" class="detailed"> SNA </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-bezier2"></i>
              </span>
            </li>
            <!-- NER -->
            <li v-if="is_ner" class="" @click="navAction">
              <router-link to="/ner" class="detailed"> NER </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-bezier"></i>
              </span>
            </li>
            <!-- NEA -->
            <li v-if="is_ner" class="" @click="navAction">
              <router-link to="/nea" class="detailed"> NEA </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-diagram-2" />
              </span>
            </li>
            <!-- MEDIA TENDENCY -->
            <!-- <li v-if="is_media_tendency" class="" @click="navAction"> -->
            <!-- <router-link to="/media-tendency" class="detailed">
                Media Tendency
              </router-link> -->
            <!-- <router-link to="/media-tendency" class="detailed">
                Tendensi Media
              </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-arrow-left-right"></i>
              </span>
            </li> -->
            <!-- TRUST METER -->
            <li v-if="is_trust_meter" class="" @click="navAction">
              <!-- <router-link to="/trust-meter" class="detailed">
                Trust Meter
              </router-link> -->
              <router-link to="/trust-meter" class="detailed">
                Pengukur Kepercayaan
              </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-diagram-3"></i>
              </span>
            </li>
            <!-- TRENDING ANALYSIS -->
            <li v-if="is_trending_analysis" class="" @click="navAction">
              <!-- <router-link to="/trending-analysis" class="detailed">
                Trending Analysis
              </router-link> -->
              <router-link to="/trending-analysis" class="detailed">
                Analisis Tren
              </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-graph-up"></i>
              </span>
            </li>
            <!-- NARASUMBER -->
            <li v-if="is_narasumber" class="" @click="navAction">
              <router-link to="/narasumber" class="detailed">
                Narasumber
              </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-person-vcard"></i>
              </span>
            </li>
            <!-- QUOTES EXTRACTION -->
            <li v-if="is_quote" class="" @click="navAction">
              <!-- <router-link to="/quote" class="detailed">
                Quotes Extraction
              </router-link> -->
              <router-link to="/quote" class="detailed">
                Ekstraksi Kutipan
              </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-chat-quote"></i>
              </span>
            </li>
            <!-- BOT & HOAX DETECTION -->
            <li v-if="is_bot" class="" @click="navAction">
              <!-- <router-link to="/bot-detection" class="detailed">
                Hoax Detection
              </router-link> -->
              <router-link to="/bot-detection" class="detailed">
                Deteksi Bot & Hoaks
              </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-exclamation-triangle"></i>
              </span>
            </li>
            <!-- TOP 10 Mention -->
            <li class="" @click="navAction">
              <router-link to="/top10-mentions" class="detailed">
                TOP 10 Mentions
              </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi-award"></i>
              </span>
            </li>
            <!-- Account Integrity -->
            <li class="" @click="navAction">
              <router-link to="/account-integrity" class="detailed">
                Kecenderungan Akun & Media
              </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi-person-workspace"></i>
              </span>
            </li>
          </ul>
        </li>
        <!-- TRENDING TOPIK -->
        <li v-if="is_trending">
          <a href="javascript:;">
            <span class="title">Trending Topik</span>
            <span class="arrow"></span>
          </a>
          <span class="icon-thumbnail">
            <i class="bi bi-clipboard-data"></i>
          </span>
          <!-- TRENDING TOPIK MENU -->
          <ul class="sub-menu">
            <!-- TWITTER TRENDING -->
            <li @click="navAction">
              <router-link to="/twitter-trending" class="detailed">
                Tren Twitter
              </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-twitter-x icon-sidebar"></i>
              </span>
            </li>
            <!-- GOOGLE TRENDING -->
            <li @click="navAction">
              <router-link to="/google-trends" class="detailed">
                Tren Google
              </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-google"></i>
              </span>
            </li>
            <!-- HEADLINE MEDIA CETAK -->
            <!-- <li @click="navAction">
              <router-link to="/headline-media-cetak-nasional" class="detailed">
                Headline Media Cetak Nasional
              </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-newspaper"></i>
              </span>
            </li> -->
          </ul>
        </li>
        <!-- TRASH BIN -->
        <li v-if="isAdmin || isAnalis" @click="navAction">
          <!-- <router-link to="/trashbin" class="detailed"> Trash Bin </router-link> -->
          <router-link to="/trashbin" class="detailed"> Trash Bin </router-link>
          <span class="icon-thumbnail"> <i class="bi bi-trash"></i> </span>
        </li>
        <!-- SETTINGS -->
        <li v-if="isAdmin || isAnalis">
          <a href="javascript:;">
            <!-- <span class="title">Settings</span> <span class="arrow"></span> -->
            <span class="title">Pengaturan</span> <span class="arrow"></span>
          </a>
          <span class="icon-thumbnail"> <i class="bi bi-gear"></i> </span>
          <!-- SETTINGS MENU -->
          <ul class="sub-menu">
            <!-- KEYWORD -->
            <li @click="navAction">
              <!-- <router-link to="/setting-keyword" class="detailed">Keyword</router-link> -->
              <router-link to="/setting-keyword" class="detailed">Kata Kunci</router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-key"></i>
              </span>
            </li>
            <!-- USERS -->
            <li @click="navAction">
              <!-- <router-link to="/setting-users" class="detailed">Users</router-link> -->
              <router-link to="/setting-users" class="detailed">Pengguna</router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-person"></i>
              </span>
            </li>
            <!-- CHANNEL -->
            <li @click="navAction">
              <!-- <router-link to="/setting-channel" class="detailed">Channel</router-link> -->
              <router-link to="/setting-channel" class="detailed">Saluran</router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-toggles2"></i>
              </span>
            </li>
            <!-- MEDIA -->
            <li @click="navAction">
              <router-link to="/setting-media" class="detailed">
                Media
              </router-link>
              <span class="icon-thumbnail rounded">
                <i class="bi bi-card-checklist"></i>
              </span>
            </li>
          </ul>
        </li>
      </ul>
      <div class="clearfix" />
    </div>
  </nav>
</template>

<script>
import $ from "jquery";
import { isMobile } from "mobile-device-detect";
import moment from "moment";

export default {
  name: "SidebarLayout",
  data() {
    return {
      is_mobile: isMobile,
      logo_proyek: this.$store.getters.user.project.project_detail.logo,
      tipe: this.$store.getters.user.project.project_detail.tipe,
      is_sna: this.$store.getters.user.project.project_detail.sna
        ? true
        : false,
      is_ner: this.$store.getters.user.project.project_detail.ner
        ? true
        : false,
      is_quote: this.$store.getters.user.project.project_detail
        .quotes_extraction
        ? true
        : false,
      is_narasumber: 1,
      is_trending: this.$store.getters.user.project.project_detail
        .twitter_trending
        ? true
        : false,
      is_bot: this.$store.getters.user.project.project_detail.bot_detection
        ? true
        : false,
      is_newstrend:
        this.$store.getters.user.capabilities != null
          ? this.$store.getters.user.capabilities.newstrend
          : "",
      is_clean:
        this.$store.getters.user.capabilities != null
          ? this.$store.getters.user.capabilities.datacleansing
          : "",
      news_trend: this.$store.getters.user.project.project_detail.news_trend,
      is_media_tendency:
        "features" in this.$store.getters.user.project.project_detail
          ? this.$store.getters.user.project.project_detail.features
            .media_tendency
          : false,
      is_trust_meter:
        "features" in this.$store.getters.user.project.project_detail
          ? this.$store.getters.user.project.project_detail.features.trust_meter
          : false,
      is_trending_analysis:
        "features" in this.$store.getters.user.project.project_detail
          ? this.$store.getters.user.project.project_detail.features
            .trending_analysis
          : false,
      isSearch:
        "features" in this.$store.getters.user.project.project_detail
          ? this.$store.getters.user.project.project_detail.features.search
            ? 1
            : 0
          : 0,
    };
  },
  computed: {
    isAnalis() {
      let user_role = this.$store.getters.user.role;
      if (user_role == 3) {
        return true;
      }
      return false;
    },
    isAdmin: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 2) {
        return true;
      }
      return false;
    },
    isProjectExpire: function () {
      if ("project" in this.$store.getters.user) {
        if ("project_detail" in this.$store.getters.user.project) {
          let status = this.$store.getters.user.project.project_detail.status;
          let project_end = this.$store.getters.user.project.project_detail
            .periode_to;
          let today = moment();
          let date_end = moment(project_end);
          let day_remain = date_end.diff(today, "days");
          if (status == 0 || day_remain < 0) {
            return true;
          }
          return false;
        }
        return false;
      }
      return false;
    },
  },
  methods: {
    navAction: function () {
      if (this.is_mobile) {
        let body = $("#apps");
        if (body.hasClass("sidebar-open")) {
          body.removeClass("sidebar-open");
          let sidebar = $(".page-sidebar");
          sidebar.removeClass("visible");
        }
      }
    },
  },
};
</script>
